import { getCVAsync, getCVFromApplicantAsync } from "@/services/cvbuilderService"

export const cvbuilder = {
    namespaced: true,
    state:{
        cv: null
    },
    getters:{
        getCVInformation(state){
            return state.cv
        }
    },
    mutations:{
        updateCVInformation(state, cv){
            state.cv = {...(state.cv || {}), ...cv}
        },
        setCVInformation(state, cv){
            state.cv = cv
        }, 
        //SKILLS
        addNewSkill(state, skill){
            state.cv.skills.push(skill);
        },
        removeSkill(state, skillId) {
            state.cv.skills = state.cv.skills.filter(skill => skill.skillId !== skillId);
        },
        updateSkillName(state, skill){
             const _skill = state.cv.skills.find(s => s.skillId === skill.skillId);
            if(_skill){
            _skill.name = skill.name; // direct mutation is fine here
            }
        }, 
        //REFERENCES
         addNewReference(state, reference){
            state.cv.references.push(reference);
        },
         updateReference(state, reference){
             const _reference = state.cv.references.find(r => r.referenceId === reference.referenceId);
            if(_reference){
            _reference.name = reference.name; // direct mutation is fine here
            _reference.company = reference.company;
            _reference.position = reference.position;
            _reference.email = reference.email;
            _reference.phone = reference.phone;
            }
        },
         removeReference(state, referenceId) {
            state.cv.references = state.cv.references.filter(r => r.referenceId !== referenceId);
        },
        ///EXPERIENCE
        addNewExperience(state, experience){
            state.cv.workExperiences.push(experience);
        },
         updateExperience(state, experience){
             const _experience = state.cv.workExperiences.find(w => w.workId === experience.workId);
            if(_experience){
            _experience.company = experience.company;
            _experience.position = experience.position;
            _experience.location = experience.location;
            _experience.startDate = experience.startDate;
            _experience.endDate = experience.endDate;
            _experience.description = experience.description; 
            }
        },
         removeExperience(state, workId) {
            state.cv.workExperiences = state.cv.workExperiences.filter(w => w.workId !== workId);
        },
         ///EDUCATION
        addNewEducation(state, education){
            state.cv.educations.push(education);
        },
         updateEducation(state, education){
             const _education = state.cv.educations.find(e => e.educationId === education.educationId);
            if(_education){
            _education.school = education.school;
            _education.certificate = education.certificate;
            _education.location = education.location;
            _education.startDate = education.startDate;
            _education.endDate = education.endDate;
            _education.description = education.description; 
            }
        },
         removeEducation(state, educationId) {
            state.cv.educations = state.cv.educations.filter(e => e.educationId !== educationId);
        },
         ///ACHIEVEMENTS
        addNewAchievement(state, achievement){
            state.cv.achievements.push(achievement);
        },
         updateAchievement(state, achievement){
             const _achievement = state.cv.achievements.find(a => a.achievementId === achievement.achievementId);
            if(_achievement){
            _achievement.name = achievement.name;
            _achievement.issuer = achievement.issuer;
            _achievement.receivedDate = achievement.receivedDate;
            _achievement.url = achievement.url; 
            }
        },
         removeAchievement(state, achievementId) {
            state.cv.achievements = state.cv.achievements.filter(a => a.achievementId !== achievementId);
        },



    },
    actions: {
        updateCVInformationAsync({commit}, data){
            commit('updateCVInformation', data)
        },
        async setCVInformationAsync({state,commit}){
            //if(state.cv == null){
                var res = await getCVAsync();
                if(!res.success){
                    const err = new Error(res.message);
                    err.caption = res.caption;
                    if(res.requireSubscription){
                        err.requireSubscription = res.requireSubscription;
                    }
                    throw err;
                }else{
                    commit('setCVInformation', res.cv);
                }
            //}
        },
        async setCVInformationFromApplicantAsync({commit}, applicantId){
            //if(state.cv == null){
                var res = await getCVFromApplicantAsync(applicantId);
                if(!res.success){
                    const err = new Error(res.message);
                    err.caption = res.caption;
                    if(res.requireSubscription){
                        err.requireSubscription = res.requireSubscription;
                    }
                    throw err;
                }else{
                    commit('setCVInformation', res.cv);
                }
            //}
        },
         //SKILLS
        addNewSkill({commit}, skill){
            commit('addNewSkill',skill);
        },
        removeSkill({commit}, skillId){
            commit('removeSkill',skillId);
        },
        updateSkillName({commit}, skill){
            commit('updateSkillName', skill);
        },
        //REFERENCES
        addNewReference({commit}, reference){
            commit('addNewReference',reference);
        },
        updateReference({commit}, reference){
            commit('updateReference', reference);
        },
         removeReference({commit}, referenceId){
            commit('removeReference',referenceId);
        },
        //EXPERIENCE
        addNewExperience({commit}, experience){
            commit('addNewExperience',experience);
        },
        updateExperience({commit}, experience){
            commit('updateExperience', experience);
        },
         removeExperience({commit}, workId){
            commit('removeExperience',workId);
        },
        //EDUCATION
        addNewEducation({commit}, education){
            commit('addNewEducation',education);
        },
        updateEducation({commit}, education){
            commit('updateEducation', education);
        },
         removeEducation({commit}, educationId){
            commit('removeEducation',educationId);
        },
        //ACHIEVEMENTS
        addNewAchievement({commit}, achievement){
            commit('addNewAchievement',achievement);
        },
        updateAchievement({commit}, achievement){
            commit('updateAchievement', achievement);
        },
         removeAchievement({commit}, achievementId){
            
            commit('removeAchievement',achievementId);
        },

        //EMPLOYER OPERATIONS
         loadCVInformation({commit}, data){
            commit('setCVInformation', data)
        },



    }
}